import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./ReadonlyCoverages.html';
import styles from './ReadonlyCoverages-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(template, styles),
        scope: {
            coverages: '=',
            filterSelected: '<'
        },
        controller: ['$scope', function (scope) {
            return scope.$watchCollection('coverages', function (coverages) {
                if (!Array.isArray(coverages)) {
                    return;
                }

                scope._coverages = coverages.filter(function (coverage) {
                    return !scope.filterSelected || coverage.selected;
                }).map(function (coverage, idx) {
                    return _.assign({}, coverage, {
                        id: coverage.publicID || idx
                    });
                });
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/readonlycoverages/ReadonlyCoverages.js
// module id = 798
// module chunks = 0